import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, Settings } from 'lucide-react';
import { useFamilyContext } from '../../contexts/FamilyContext';

export default function ManagePageHeader() {
  const { currentUser, family, kidAllowances } = useFamilyContext();
  
  const isParent = currentUser?.isParent;
  
  // Calculate balance display
  const getBalanceInfo = () => {
    if (isParent) {
      // Parents see total family balance (sum of all kids' balances)
      const totalOwed = family?.kids?.reduce((total, kid) => {
        const allowance = kidAllowances[kid.id];
        return total + (allowance?.current_balance || 0);
      }, 0) || 0;
      
      return {
        title: 'Family Allowance Balance',
        amount: `$${totalOwed.toFixed(2)}`,
        subtitle: 'Total owed to kids'
      };
    } else {
      // Kids see their personal balance
      const allowance = kidAllowances[currentUser?.id];
      const balance = allowance?.current_balance || 0;
      
      return {
        title: 'My Balance',
        amount: `$${balance.toFixed(2)}`,
        subtitle: null
      };
    }
  };

  const balanceInfo = getBalanceInfo();
  const backPath = isParent ? "/parent-dashboard" : "/dashboard";

  return (
    <header className="manage-header">
      <div className="manage-header-content">
        <Link to={backPath} className="manage-back-btn">
          <ChevronLeft className="w-5 h-5" />
        </Link>
        <div className="manage-page-title">
          {isParent ? 'Manage' : 'My Stuff'}
        </div>
        <Link to="/settings" className="manage-settings-btn">
          <Settings className="w-5 h-5" />
        </Link>
      </div>
      
      <div className="manage-balance-section">
        <div className="manage-balance-title">{balanceInfo.title}</div>
        <div className="manage-balance-amount">{balanceInfo.amount}</div>
        {balanceInfo.subtitle && (
          <div className="manage-balance-subtitle">{balanceInfo.subtitle}</div>
        )}
      </div>
    </header>
  );
}